import type { Template } from "@/types";

export const LA_03_H2_V1: Template[] = [
    {
        id: "la-03-h2v1-01",
        name: "LA 01 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 174, y: 38, width: 329, height: 465, rotation: 0, imageRotation: 0 },
            { id: "2", x: 833, y: 37, width: 361, height: 230, rotation: 0, imageRotation: 0 },
            { id: "3", x: 833, y: 275, width: 361, height: 229, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-02",
        name: "LA 02 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 172, y: 44, width: 332, height: 456, rotation: 0, imageRotation: 0 },
            { id: "2", x: 717, y: 165, width: 294, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 165, width: 294, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-03",
        name: "LA 03 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 47, y: 41, width: 332, height: 457, rotation: 0, imageRotation: 0 },
            { id: "2", x: 953, y: 41, width: 352, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 953, y: 275, width: 352, height: 225, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-04",
        name: "LA 04 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_04.png",
        size: [1352, 541],
        style: {},
        slots: [          
            { id: "1", x: 162, y: 38, width: 352, height: 229, rotation: 0, imageRotation: 0 },
            { id: "2", x: 162, y: 275, width: 352, height: 228, rotation: 0, imageRotation: 0 },
            { id: "3", x: 852, y: 38, width: 324, height: 465, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-05",
        name: "LA 05 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_05.png",
        size: [1352, 541],
        style: {},
        slots: [        
            { id: "1", x: 40, y: 162, width: 294, height: 220, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 162, width: 294, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 849, y: 44, width: 330, height: 456, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-06",
        name: "LA 06 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_06.png",
        size: [1325, 530],
        style: {},
        slots: [
            { id: "1", x: 0, y: 86, width: 526, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 534, y: 86, width: 259, height: 358, rotation: 0, imageRotation: 0 },         
            { id: "3", x: 801, y: 86, width: 524, height: 358, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-07",
        name: "LA 07 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_07.png",
        size: [1325, 530],
        style: {},
        slots: [
            { id: "1", x: 62, y: 103, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 546, y: 103, width: 234, height: 324, rotation: 0, imageRotation: 0 },     
            { id: "3", x: 788, y: 103, width: 475, height: 324, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-08",
        name: "LA 08 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_08.png",
        size: [1325, 530],
        style: {},
        slots: [       
            { id: "1", x: 0, y: 86, width: 526, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 534, y: 86, width: 525, height: 358, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1067, y: 86, width: 258, height: 358, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-09",
        name: "LA 09 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_09.png",
        size: [1325, 530],
        style: {},
        slots: [
            { id: "1", x: 62, y: 103, width: 234, height: 324, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 304, y: 103, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 788, y: 103, width: 475, height: 324, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-10",
        name: "LA 10 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_10.png",
        size: [1325, 530],
        style: {},
        slots: [         
            { id: "1", x: 62, y: 103, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 546, y: 103, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1030, y: 103, width: 233, height: 324, rotation: 0, imageRotation: 0 }
        ],
    }
];